import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _slicedToArray from "D:\\ax2\\deployment\\ax2new\\AccessExpress\\web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:\\ax2\\deployment\\ax2new\\AccessExpress\\web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _typeof from "D:\\ax2\\deployment\\ax2new\\AccessExpress\\web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import * as React from 'react';
import { createTable } from '@tanstack/table-core';
export * from '@tanstack/table-core'; //

/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */

function flexRender(Comp, props) {
  return !Comp ? null : isReactComponent(Comp) ?
  /*#__PURE__*/
  React.createElement(Comp, props) : Comp;
}

function isReactComponent(component) {
  return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
}

function isClassComponent(component) {
  return typeof component === 'function' && function () {
    var proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  }();
}

function isExoticComponent(component) {
  return _typeof(component) === 'object' && _typeof(component.$$typeof) === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
}

function useReactTable(options) {
  // Compose in the generic options to the user options
  var resolvedOptions = _objectSpread({
    state: {},
    // Dummy state
    onStateChange: function onStateChange() {},
    // noop
    renderFallbackValue: null
  }, options); // Create a new table and store it in state


  var _React$useState = React.useState(function () {
    return {
      current: createTable(resolvedOptions)
    };
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      tableRef = _React$useState2[0]; // By default, manage table state here using the table's initial state


  var _React$useState3 = React.useState(function () {
    return tableRef.current.initialState;
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      state = _React$useState4[0],
      setState = _React$useState4[1]; // Compose the default state above with any user state. This will allow the user
  // to only control a subset of the state if desired.


  tableRef.current.setOptions(function (prev) {
    return _objectSpread({}, prev, {}, options, {
      state: _objectSpread({}, state, {}, options.state),
      // Similarly, we'll maintain both our internal state and any user-provided
      // state.
      onStateChange: function onStateChange(updater) {
        setState(updater);
        options.onStateChange == null || options.onStateChange(updater);
      }
    });
  });
  return tableRef.current;
}

export { flexRender, useReactTable };